import React, { useContext } from "react";
import {
  Box,
  Grid,
  Stack,
  TextField,
  IconButton,
  Typography,
} from "@mui/material";
import "../../Style/dialogstyle.scss";
import { SelectItem } from "../Include/DynamicSelect";
import { AuthContext } from "../../Context/AuthContext";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { translateLauguage } from "../../Function/Translate";
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

export default function ListPayment({ listPaymentData, setListPaymentData, required, currency }) {
  // Change Language
  const { language, setAlert } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const paymentItem = {
    memo: "",
    amount: 0,
    endDate: null,
    startDate: null,
    item: { id: "", title: "" },
    key: Date.now() + Math.random(),
  }

  const handeAddItem = () => setListPaymentData([...listPaymentData, paymentItem]);

  const handeRemoveItem = (key) => {
    const data = listPaymentData.filter(e => e.key !== key);
    setListPaymentData(data);
  }

  const handeChangeValue = (key, fieldName, value) => {
    const data = listPaymentData.map((e) => {

      if (e.key === key && fieldName === "item") e.item = value;
      if (e.key === key && fieldName === "memo") e.memo = value;
      if (e.key === key && fieldName === "endDate") e.endDate = value;
      if (e.key === key && fieldName === "startDate") e.startDate = value;
      if (e.key === key && fieldName === "amount") e.amount = parseFloat(value);

      return e;
    });
    setListPaymentData(data);
  }


  return (

    <Stack direction="column" spacing={1} >
      <Stack direction="row" alignItems="center" justifyContent="space-between" >
        <Typography className="field-title" sx={{ fontWeight: "bold", fontSize: 16 }}>List Payment</Typography>
        <IconButton sx={{ marginRight: 1 }} onClick={handeAddItem}>
          <AddBoxOutlinedIcon sx={{ color: "green" }} />
        </IconButton>
      </Stack>
      <Stack direction="column" spacing={2} minHeight={400} >
        {listPaymentData?.map((e, index) => (
          <Stack
            key={index}
            direction="row"
            alignItems="center"
            sx={{
              borderRadius: 2,
              boxShadow: "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px"
            }}
          >
            <Grid container
              rowSpacing={1}
              columnSpacing={2}
              sx={{ padding: 2.2, paddingRight: 1.5, paddingTop: 1.2 }}
            >
              <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                <Typography className="field-title">Item</Typography>
                <SelectItem
                  required={required}
                  selectedVal={e?.item}
                  setSelectedVal={(value) => handeChangeValue(e.key, "item", value)}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                <Typography className="field-title">
                  Start Date
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    className="search-field"
                    value={e?.startDate}
                    onChange={(newValue) => handeChangeValue(e.key, "startDate", newValue)}
                    renderInput={(params) => <TextField {...params} size="small" fullWidth error={required && !e?.startDate} />}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                <Typography className="field-title">
                  End Date
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    className="search-field"
                    value={e?.endDate}
                    onChange={(newValue) => handeChangeValue(e.key, "endDate", newValue)}
                    renderInput={(params) => <TextField {...params} size="small" fullWidth error={required && !e?.endDate} />}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} sm={6} md={8} lg={8} xl={8}>
                <Typography className="field-title">Memo</Typography>
                <TextField
                  fullWidth
                  size="small"
                  value={e?.memo}
                  className="text-field"
                  placeholder="description"
                  onChange={({ target }) => handeChangeValue(e.key, "memo", target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                <Typography className="field-title">Amount</Typography>
                <TextField
                  InputProps={{
                    inputProps: { min: 0, },
                    endAdornment: currency === "USD" ? "$" : "៛",

                  }}
                  fullWidth
                  size="small"
                  type="number"
                  value={e?.amount}
                  className="text-field"
                  error={required && !e?.amount}
                  onChange={({ target }) => handeChangeValue(e.key, "amount", Math.max(target.value, 0))}
                />
              </Grid>
            </Grid >
            <Box>
              <IconButton sx={{ marginRight: 1 }} onClick={() => handeRemoveItem(e?.key)}>
                <CloseOutlinedIcon sx={{ color: "red" }} />
              </IconButton>
            </Box>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
}
